import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Chip
} from "@mui/material";

const EmployeeHolidays = () => {
  const baseURL = process.env.REACT_APP_API_URL;
  const [holidays, setHolidays] = useState([]);

  const fetchHolidays = async () => {
    try {
      const res = await axios.get(`${baseURL}holidays`);
      setHolidays(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchHolidays();
  }, []);

  const today = new Date().toISOString().split("T")[0];

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Holiday Calendar
      </Typography>

      <Box sx={{ display: "grid", gap: 2 }}>
        {holidays.map((h) => {
          const holidayDate = h.date || h.start_date;

          const isToday = holidayDate === today;

          return (
            <Card
              key={h.id}
              sx={{
                borderLeft: isToday ? "5px solid green" : "5px solid #1976d2",
                backgroundColor: isToday ? "#e8f5e9" : "#fff"
              }}
            >
              <CardContent>
                <Typography variant="h6">
                  {h.title}
                </Typography>

                <Typography variant="body2" sx={{ mb: 1 }}>
                  {h.date
                    ? `Date: ${h.date}`
                    : `${h.start_date} → ${h.end_date}`}
                </Typography>

                {h.is_optional && (
                  <Chip
                    label="Optional"
                    color="warning"
                    size="small"
                    sx={{ mr: 1 }}
                  />
                )}

                {isToday && (
                  <Chip
                    label="Today"
                    color="success"
                    size="small"
                  />
                )}

                {h.description && (
                  <Typography variant="body2" sx={{ mt: 1 }}>
                    {h.description}
                  </Typography>
                )}
              </CardContent>
            </Card>
          );
        })}
      </Box>
    </Box>
  );
};

export default EmployeeHolidays;